import React from 'react';
import { clientLogos } from '../../data/mock';

const ClientsSection = () => {
  // Double the logos for seamless infinite scroll
  const duplicatedLogos = [...clientLogos, ...clientLogos];

  return (
    <section className="py-12 sm:py-16 bg-gradient-to-b from-white to-[var(--bg-page)] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-10">
          <h2 className="heading-2 mb-2 text-lg sm:text-xl md:text-2xl">
            Built by the Team, That Served <span className="gradient-text">100+ Clients</span> including...
          </h2>
          <p className="body-medium text-[var(--text-muted)] text-sm sm:text-base">
            Trusted by leading companies across industries
          </p>
        </div>

        {/* Logo Marquee */}
        <div className="relative">
          {/* Gradient Overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-[var(--bg-page)] to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-[var(--bg-page)] to-transparent z-10" />
          
          {/* Scrolling Container */}
          <div className="overflow-hidden">
            <div className="logo-marquee animate-scroll">
              {duplicatedLogos.map((logo, index) => (
                <div
                  key={`${logo.id}-${index}`}
                  className="flex-shrink-0 mx-4 group"
                >
                  <div className="w-36 h-24 bg-white rounded-lg border border-gray-100 shadow-sm flex items-center justify-center p-2 group-hover:shadow-md group-hover:border-[var(--brand-teal-200)] transition-all">
                    <img
                      src={logo.image}
                      alt={logo.name}
                      className="w-full h-full object-contain filter grayscale hover:grayscale-0 transition-all"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
